import moment from "moment"
import React, { useEffect, useState } from "react"
import { Col, Row, Table, Modal } from "react-bootstrap"
import toast from "react-hot-toast"
import { useNavigate, useParams } from "react-router-dom"
import cleanLogo from "../../../Assets/Images/Login/transparent_bg.png"
import Navbar from "../../../Components/Navbar/Navbar"
import NoDataImg from "../../../Assets/Images/no-data-img.png"
import {
  dateFormat,
  getTodayDateISO,
  numberFormat,
  refreshPage,
  toastStyle,
  TokenExpiry,
} from "../../../Helpers/Utils/Common"
import { getExpenses } from "../../../Helpers/apiCalls/Reports/DailyExpensesApi"
import noDataImg from "../../../Assets/Images/no-data-img.png"
import Footer from "../../../Components/Footer/Footer"

export default function PrintDailyExpenses() {
  const { id, shop } = useParams() // id
  let navigate = useNavigate()

  const [inactive, setInactive] = useState(true)
  const [expense, setExpense] = useState([])
  const [items, setItems] = useState([])
  const [image, setImage] = useState("")
  const [preview, setPreview] = useState(false)
  const [previewFile, setPreviewFile] = useState("")
  const [fileList, setFileList] = useState([])

  const [showViewModal, setShowViewModal] = useState(false)
  const handleShowViewModal = (img) => {
    setImage(img)
    setShowViewModal(true)
  }
  const handleCloseViewModal = () => {
    setShowViewModal(false)
    setImage("")
  }

  async function fetchExpense() {
    setExpense([])
    setItems([])

    const response = await getExpenses({ id: id })

    if (response.error) {
      TokenExpiry(response)
    } else {
      var expense = response.data.data.map((data) => {
        var info = data
        return info
      })
      var expenseItem = expense[0]?.expense_item.map((data) => {
        var info = data
        info.store = expense[0].store_name
        info.qty = numberFormat(data.qty)
        info.price = numberFormat(data.price)
        info.total = numberFormat(data.total)
        info.added_on = new Date(data.added_on).toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
        })
        return info
      })
      setExpense(expense[0])
      setFileList(expense[0].attachment)
      setItems(expenseItem)
    }
  }

  async function handlePrint() {
    toast.loading("Printing sales invoice...", { style: toastStyle() })
    setTimeout(() => {
      toast.dismiss()
      Print()
    }, 1000)
  }

  function renderTable() {
    return (
      <Table className="align-middle">
        <thead>
          <tr>
            <th>Item</th>
            <th>Quantity</th>
            <th>Unit</th>
            <th>Price</th>
            <th>Amount</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item) => {
            return (
              <tr>
                <td>{item.name}</td>
                <td>{item.qty}</td>
                <td className="text-lowercase">{item.unit}</td>
                <td>{item.price}</td>
                <td>{item.total}</td>
              </tr>
            )
          })}
          <tr>
            <td colSpan={3}></td>
            <td>Grand Total</td>
            <td>
              PHP{" "}
              {expense.grand_total ? numberFormat(expense.grand_total) : "0.00"}
            </td>
          </tr>
        </tbody>
      </Table>
    )
  }

  function Print() {
    let printContents = document.getElementById("printablediv").innerHTML
    let originalContents = document.body.innerHTML
    document.body.innerHTML = printContents
    window.print(printContents)
    document.body.innerHTML = originalContents
    refreshPage()
  }

  useEffect(() => {
    fetchExpense()
  }, [])

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive)
          }}
          active={"DS REPORTS"}
        />
      </div>
      <div
        className={`manager-container ${
          inactive ? "inactive" : "active"
        } review-container-main`}
      >
        <br />
        <br />
        <div className="print-container px-3 py-2" id="printablediv">
          {/* <div className="text-end print-header d-flex flex-column">
            <span>EXPENSE NO. {id}</span>
            <span className="text-uppercase">
              {moment(getTodayDateISO()).format("MMMM DD, yyyy")}
            </span>
          </div>
          <div className="d-flex justify-content-center py-1">
            <img src={cleanLogo} className="print-logo" alt="" />
          </div> */}
          <div className="print-header-elm d-flex flex-column flex-sm-row pt-3">
            <div className="w-full">
              <div className="print-top d-flex justify-content-center justify-content-sm-start">
                <img src={cleanLogo} className="print-logo-elm w-xl" alt="" />
              </div>
              <div className="print-top d-flex flex-column">
                <h5 className="print-label fw-bold">LEYTE PAPERWORLD</h5>
                <h5 className="print-label fw-bold">
                  168 M.H. Del Pilar, Tacloban City, Leyte
                </h5>
                <h5 className="print-label fw-bold">09708488855</h5>
              </div>
            </div>
            <div className="purchase-order-number-print-container w-full my-3 m-sm-0">
              <h1 className="purchase-order-title-print-elm">
                EXPENSE NO. {id}
              </h1>
              <h5 className="print-label fw-bold">09708488855</h5>
            </div>
          </div>

          {/* content */}
          <div className="print-body mt-5 justify-content-start">
            <Row className="d-flex align-items-start">
              <Col xs={12} lg={6}>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    Branch:
                  </Col>
                  <Col xs={7} className="print-data">
                    {expense.branch_name}
                  </Col>
                </div>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    Store:
                  </Col>
                  <Col xs={7} className="print-data">
                    {expense.store_name}
                  </Col>
                </div>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    Invoice No:
                  </Col>
                  <Col xs={7} className="print-data">
                    {expense.invoice_no}
                  </Col>
                </div>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    Remarks:
                  </Col>
                  <Col xs={7} className="print-data">
                    {expense.remarks}
                  </Col>
                </div>
              </Col>
              <Col xs={12} lg={6}>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    Expense Date:
                  </Col>
                  <Col xs={7} className="print-data">
                    {dateFormat(expense.expense_date)}
                  </Col>
                </div>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    Encoded By:
                  </Col>
                  <Col xs={7} className="print-data">
                    {expense.encoded_by_name}
                  </Col>
                </div>
              </Col>
            </Row>
            <div className="d-flex mt-5 mb-2 justify-content-evenly">
              {/* table */}
              <div className="print-table mt-3 mx-2">{renderTable()}</div>
            </div>
          </div>
        </div>
        <Row className="review-data mb-2 mt-3 ms-2">FILE ATTACHMENTS</Row>
        <Row className="">
          {fileList &&
            fileList.map((attachment) => (
              <Col
                xs={1}
                onClick={() => {
                  setPreviewFile(attachment.file_url)
                  setPreview(true)
                }}
                className="cursor-pointer preview-container"
              >
                <img src={attachment.file_url} className="img-preview" />
              </Col>
            ))}
          {!fileList ||
            (fileList.length === 0 && (
              <Col xs={1}>
                <div className="no-data-cont d-flex justify-content-left preview-container">
                  <img
                    src={noDataImg}
                    alt="no data found"
                    className="img-preview"
                  />
                </div>
              </Col>
            ))}
        </Row>

        {/* footer */}
        <div className="d-flex justify-content-end my-4 pb-5 d-flex-responsive">
          <button
            className="button-secondary me-3"
            onClick={() => navigate(-1)}
          >
            Close
          </button>
          <button className="button-primary" onClick={handlePrint}>
            Print
          </button>
        </div>
      </div>
      <Modal
        show={showViewModal}
        onHide={() => handleCloseViewModal()}
        size="md"
        centered
      >
        <Modal.Body className="pt-5">
          <div className="row justify-content-center">
            <div
              className="col-sm-12 align-center"
              style={{ textAlignLast: "center" }}
            >
              <img
                src={`data:image/png;base64,${image}`}
                width={400}
                height={400}
                alt=""
              />
            </div>
          </div>
          <div className="d-flex justify-content-center my-4">
            <button
              className="button-secondary"
              onClick={() => handleCloseViewModal()}
            >
              Close
            </button>
          </div>
        </Modal.Body>
      </Modal>
      {/* VIEW ATTACHMENT MODAL */}
      <Modal
        open={preview}
        title={""}
        footer={null}
        onCancel={() => setPreview(false)}
      >
        <Row className="justify-content-center">
          <img
            alt="attachment"
            style={{
              width: "100%",
            }}
            src={previewFile}
          />
        </Row>
      </Modal>
      <Footer />
    </div>
  )
}
